/* EulaSectionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EulaSectionRenderer");
const _ = require("lodash");
class EulaSectionComponent extends EventEmitter {
    constructor(logger, userService, userSession, router, SystemDetails, localStorage) {
        super();
        this._renderer = new Renderer(this);

        this._logger = logger;
        this._userService = userService;
        this._userSession = userSession;
        this._router = router;
        this._SystemDetails = SystemDetails;
        this._localStorage = localStorage;
        this._redirect = _.get(this._router.routeDetails, "rd.redirect", false);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer
            .shutdown()
            .then(() => (this._renderer = undefined))
            .catch(() => {
                //TODO - Handle any errors in shutting down.
            });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    returnToLogin() {
        // this._userSession.logout().then(() => {
        //     this._localStorage.setToken(null);
        //     this._router.goTo({app: "GameConsole", s: "LoginCenter", sln: null});
        // });

        this._logout();
    }

    _logout() {
        const token = this._userSession.token || this._localStorage.getToken();
        localStorage.clear();
        location.href = `${window.origin}/session/logout/${token}%2Feula`;
    }

    updateUserEulaAccept() {
        this._userSession.user
            .acceptEula({})
            .then(() => {
                return this._SystemDetails.loadSystemDetails(
                    this._userSession.activeOrganization.id
                );
            })
            .then((details) => {
                const banner = _.get(details[0], "banner", undefined);
                if (banner && banner.enable) {
                    let bannerFromStorage = window.sessionStorage.getItem(
                        this._userSession.token + "banner"
                    );
                    if (
                        !this._userSession.user.bannerAcceptTime ||
                        (banner.displayMode === "ALWAYS" && !bannerFromStorage)
                    ) {
                        this._router.goTo({
                            app: "GameConsole",
                            s: "Banner",
                            rd: {triggeredBy: "Eula", redirect: this._redirect},
                        });
                        return;
                    }
                }

                const loadPath = window.localStorage.getItem("loadpath");
                if (loadPath) {
                    window.localStorage.removeItem("loadpath");
                    window.location = loadPath;
                    return;
                }

                if (this._redirect && this._redirect.s !== "Eula") {
                    if (this._redirect.sln === "classic") {
                        window.location =
                            window.origin + "/_app_/gluware_control/#!/s/Perspective/rd/";
                        return;
                    }
                    this._router.goTo(this._redirect);
                    return;
                }

                let lastPathInfo = window.sessionStorage.getItem(
                    this._userSession.user.id + "lastPathInfo"
                );
                if (lastPathInfo) {
                    if (lastPathInfo.search("/s/Perspective/") >= 0) {
                        window.location.href =
                            window.origin + "/_app_/gluware_control/#!" + lastPathInfo;
                        return;
                    } else if (lastPathInfo.search("/frontend/") >= 0) {
                        window.location = window.origin + lastPathInfo;
                    } else {
                        window.location.hash = "#!" + lastPathInfo;
                        return;
                    }
                }

                this._router.goTo({
                    app: "GameConsole",
                    s: "Dashboard",
                    sln: null,
                    sr: null,
                    rd: {triggeredBy: "Eula"},
                    ra: "dashboard",
                });
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

EulaSectionComponent.$inject = [
    "$teve.logger",
    "$teve.services.User",
    "$teve.userSession",
    "$teve.router",
    "$teve.entities.SystemDetails",
    "$teve.userLocalStorage",
];

module.exports = EulaSectionComponent;
